import { localize } from "@gtmhub/localization";

export function attainmentOperator() {
  return function (value: string) {
    const operators: Record<string, string> = {
      ">": localize("greater_than"),
      "<=": localize("equal_lower_than"),
      "<": localize("lower_than"),
      ">=": localize("equal_greater_than"),
      "=": localize("equal_to"),
    };

    let operator: string = null;
    let attainment: number = null;

    const substr = value.substr(0, 2);

    if (operators[substr]) {
      operator = operators[substr];
      attainment = parseFloat(value.split(substr)[1]) * 100;
    } else {
      operator = operators[value.substr(0, 1)];
      attainment = parseFloat(value.substr(1, 5)) * 100;
    }
    return `${operator} ${attainment}`;
  };
}
